import {Component, Inject, Input} from 'ng-metadata/core';
import {SearchErrorMessageService} from './searchErrorMessage.service';

@Component({
    selector: 'prm-search-error-message',
    templateUrl: 'components/search/searchResult/errorMessage/search-error-message.html',
})

export class PrmSearchErrorMessage {

    @Input() private errorCode: string;
    @Input() private errorMessage: string[];

    constructor( @Inject('$translate') private $translate,
                 @Inject('errorMessageIcons') public errorMessageIcons: any,
                 private searchErrorMessageService: SearchErrorMessageService){
    }

    getErrorHeader() {
        return this.$translate.instant('nui.' + this.errorCode + '.header');
    }

    getErrorDescription() {
        if (this.errorCode === this.searchErrorMessageService.tooManyBoolean) {
            return this.$translate.instant('nui.' + this.errorCode, { 'idx_0': this.errorMessage[0], 'idx_1': this.errorMessage[1] });
        }
        if (this.errorCode === this.searchErrorMessageService.expansionUiNotice && this.errorMessage) {
            return this.$translate.instant('nui.' + this.errorCode + '_long_query', { 'idx_0': this.errorMessage[0] });
        }
        return this.$translate.instant('nui.' + this.errorCode);
    }

    getErrorSuggestionHeader() {
        if (this.errorCode === this.searchErrorMessageService.tooManyClauses
            || this.errorCode === this.searchErrorMessageService.illegalSearchTerm
            || this.errorCode === this.searchErrorMessageService.crossSystemLimits
			|| this.errorCode === this.searchErrorMessageService.tooLong
            || this.errorCode === this.searchErrorMessageService.tooManyBoolean
            || (this.errorCode === this.searchErrorMessageService.expansionUiNotice && this.errorMessage)) {
            return this.$translate.instant('nui.search.error.noresults.suggestions.header');
        }
        return null;
    }

    getErrorSuggestionsDescription() {
        let suggestionsList: Array<string> = [];
        if ((this.errorCode === this.searchErrorMessageService.expansionUiNotice && this.errorMessage)
			|| this.errorCode === this.searchErrorMessageService.tooLong
            || this.errorCode === this.searchErrorMessageService.tooManyBoolean) {
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion1'));
        }
        else if (this.errorCode === this.searchErrorMessageService.illegalSearchTerm
                || this.errorCode === this.searchErrorMessageService.tooManyClauses) {
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion1'));
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion2'));
        }
        else if (this.errorCode === this.searchErrorMessageService.crossSystemLimits) {
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion1'));
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion2'));
            suggestionsList.push(this.$translate.instant('nui.' + this.errorCode + '.suggestion3'));
        }
        return suggestionsList;
    }

    showNoResultsIcon() {
        if (this.errorCode === this.searchErrorMessageService.illegalSearchTerm
            || this.errorCode === this.searchErrorMessageService.crossSystemLimits
            || this.errorCode === this.searchErrorMessageService.serverError) {
            return true;
        }
        return false;
    }

    showAttentionIcon() {
        if (this.errorCode === this.searchErrorMessageService.blendedTimeout
            || this.errorCode === this.searchErrorMessageService.notAllSlicesSearched) {
            return true;
        }
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/errorMessage/searchErrorMessage.directive.ts